import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const formatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
})

const SalaryAdvancePrice = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          salaryAdvance {
            fee
          }
        }
      }
    }
  `)

  return <span>{formatter.format(data.site.siteMetadata.salaryAdvance.fee)}</span>
}

export default SalaryAdvancePrice
